import styled from 'styled-components';

import { StyledControlBarButton } from '../../control-bar-button.styles';

export const StyledAddBookToShelfButton = styled(StyledControlBarButton)`
  transform: translateY(3px);

  &:hover {
    & rect {
      fill: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
          .booksIconColorOnHover};
    }

    & line {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
          .booksIconColorOnHover};
    }
  }

  &:active {
    & rect {
      fill: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
          .iconColorOnActive};
    }

    & line {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
          .iconColorOnActive};
    }
  }
`;
